




























































































































































































import { Component, Vue } from 'vue-property-decorator';
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import * as VueGoogleMaps from 'vue2-google-maps'
import {
    Dealership,
    VehicleLog, VehicleFilter
} from "../../types";
import {
    getMapMarkers,
    getMostRecentAccidentVehicles,
    getVehicleCountForLastThreeMonthsForDealer,
    searchByArea, searchByDealership
} from "../../endpoints";
import SearchTemplate from "../templates/SearchTemplate.vue";
import AutoComplete from "v-autocomplete";
import dateFormat from "date-fns/format";
import dateSub from "date-fns/subDays";
import {buildDealershipLink, buildVehicleLink, paths} from "../../path";
import {GoogleMapKey} from "../../environment";
import Search from "../utility/Search.vue";

Vue.component("v-search", Search);
Vue.component('GmapCluster', GmapCluster);
Vue.component('InfoWindow', VueGoogleMaps.InfoWindow);

Vue.use(VueGoogleMaps, {
    load: {
        key: GoogleMapKey
    }
});

Vue.use(AutoComplete);

@Component
export default class Map extends Vue {

    // Expose our constants
    DateFormat = dateFormat;
    DateSub = dateSub;
    BuildDealershipLink = buildDealershipLink;
    Paths = paths;

    SearchByDealership = searchByDealership;
    SearchByArea = searchByArea;

    // Set when a search is performed. This is used specifically for animations.
    currentlySelectedDealerSearchItem = null;
    currentlySelectedAreaSearchItem = null;

    currentlySelectedMarker: Dealership = null;

    recentAccidentVehicles: VehicleLog[] = [];

    markerBoundsChangeTimeout = null;

    markers: Dealership[] = [];

    markerInfoWindowPosition = null;
    markerInfoWindowOpened = false;
    markerInfoWindowOptions = {
        content: '',
        pixelOffset: {
            width: 0,
            height: -35
        }
    };

    mapDealershipFilters = {
        activeAccident: true,
        activeNoAccident: true,
        inactiveAccident: true,
        inactiveNoAccident: true
    };

    // Location of USA
    mapCenterLocation = { lat: 37.09024, lng: -95.71289100000001 };
    currentMapBounds: {
        swLat: number,
        swLng: number,
        neLat: number,
        neLng: number
    } = null;

    // Reference to interval responsible for fetching recent vehicle finds
    recentAccidentsInterval;

    lastThreeMonthVehicleCountResults: { date: string, vehicle_count: number }[] = [];

    loadingRecentAccidents: boolean = false;
    loadingDealershipVehicleHistory: boolean = false;
    loadingMarkers: boolean = false;

    async mounted() {
        this.loadMarkers();

        this.getRecentAccidents();

        this.recentAccidentsInterval = window.setInterval(() => {
            this.getRecentAccidents();
        }, 30000);

        window['_event_info_window_view_history_button_click'] = this.onViewHistoryButtonClick;
        window['_event_info_window_dealership_title_click'] = this.onInfoWindowDealershipLinkClick;

        const map = await (this.$refs.mapRef as any).$mapPromise;

        // Could use idle event, but we could also just debounce, so it's whatever...
        map.addListener('bounds_changed', e => {

            const bounds = map.getBounds();
            const ne = bounds.getNorthEast();
            const sw = bounds.getSouthWest();

            /*if(this.currentMapBounds
                && this.currentMapBounds.swLng <= sw.lng()
                && this.currentMapBounds.swLat <= sw.lat()
                && this.currentMapBounds.neLng <= ne.lng()
                && this.currentMapBounds.neLat <= ne.lat()) {
                return;
            }*/

            window.clearTimeout(this.markerBoundsChangeTimeout);

            this.markerBoundsChangeTimeout = window.setTimeout(() => {
                if(map.getZoom() >= 8) {
                    this.currentMapBounds = {
                        neLat: ne.lat(),
                        neLng: ne.lng(),
                        swLat: sw.lat(),
                        swLng: sw.lng()
                    };

                    this.loadMarkers();
                }
            },800);
        });
    }

    beforeDestroy() {
        delete window['_event_info_window_view_history_button_click'];
        delete window['_event_info_window_dealership_title_click'];
        clearInterval(this.recentAccidentsInterval);
    }

    async loadMarkers() {

        if(!this.currentMapBounds) {
            return;
        }

        const params = new URLSearchParams();

        if(this.currentlySelectedAreaSearchItem) {
            params.append("area", `${this.currentlySelectedAreaSearchItem.id}`)
        } else {
            params.append("ne-lat", `${this.currentMapBounds.neLat}`);
            params.append("ne-lng", `${this.currentMapBounds.neLng}`);
            params.append("sw-lat", `${this.currentMapBounds.swLat}`);
            params.append("sw-lng", `${this.currentMapBounds.swLng}`);
        }

        this.loadingMarkers = true;

        this.markers = await getMapMarkers(params.toString());

        this.loadingMarkers = false;

        if(this.currentlySelectedDealerSearchItem) {
            window.setTimeout(() => {
                this.currentlySelectedDealerSearchItem = null;
            }, 3000);
        }
    }

    onSearchAreaFilterInput(item) {
        this.currentlySelectedAreaSearchItem = item;

        this.loadMarkers();

        /*if(item) {
            this.filterAreaCurrentItemSet = true;
            this.filterAreaCurrentItem = item.id;
            this.loadMarkers();
        } else if(this.filterAreaCurrentItemSet) {
            this.filterAreaCurrentItemSet = false;
            this.filterAreaCurrentItem = null;
            this.loadMarkers();
        }*/
    }

    onLegendItemClick(s: string) {
        this.mapDealershipFilters[s] = !this.mapDealershipFilters[s];
    }

    async onDealershipSearchResultsItemClick(item) {
        if(item) {
            const map = await (this.$refs.mapRef as any).$mapPromise;
            const { latitude, longitude, id } = item;

            map.setZoom(10);
            map.panTo({ lat: latitude, lng: longitude });

            this.currentlySelectedDealerSearchItem = id;
        }
    }

    async getRecentAccidents() {
        this.loadingRecentAccidents = true;

        try {

            const recentAccidents = await getMostRecentAccidentVehicles();

            if(this.recentAccidentVehicles.length) {
                if(recentAccidents.length !== this.recentAccidentVehicles.length) {
                    (this as any).$bvToast.toast('Check the table for more information.', {
                        title: '"Recent finds" has been updated',
                        autoHideDelay: 8000,
                        variant: 'secondary',
                        solid: true
                    })
                }
            }

            this.recentAccidentVehicles = recentAccidents;

        } catch (e) {
            console.error(e);
        } finally {
            this.loadingRecentAccidents = false;
        }
    }

    getApplicableMarkerIcon(marker: Dealership) {
        if(marker.is_active && marker.has_recent_accidents) {
            return "/images/active-with-accident.png";
        } else if(marker.is_active && !marker.has_recent_accidents) {
            return "/images/active-with-no-accident.png";
        } else if(!marker.is_active && marker.has_recent_accidents) {
            return "/images/inactive-with-accident.png";
        } else if(!marker.is_active && !marker.has_recent_accidents) {
            return "/images/inactive-with-no-accident.png";
        }
    }

    onMarkerClick(id) {
        const targetMarker: any = this.markers.filter(marker => {
            return marker.id === id
        })[0];

        const liveStartingDate = this.DateFormat(this.DateSub(new Date(), 14), "yyyy-MM-dd");
        const liveEndingDate = this.DateFormat(new Date(), "yyyy-MM-dd");

        this.currentlySelectedMarker = targetMarker;
        this.markerInfoWindowPosition = { lat: targetMarker.latitude, lng: targetMarker.longitude };
        this.markerInfoWindowOpened = true;
        this.markerInfoWindowOptions.content = `<div class="text-center">
            <a onclick="window['_event_info_window_dealership_title_click']('${targetMarker.dealership_uri}')" class="text-sm" href="javascript:void(0)">${targetMarker.name}</a>
            <button onclick="window['_event_info_window_view_history_button_click'](${id})" class="btn btn-sm btn-success btn-block mt-2">View Recent History</button>
            <a target="_blank" href="${this.BuildDealershipLink(targetMarker.dealership_uri)}?start=${liveStartingDate}&end=${liveEndingDate}&view=${VehicleFilter.LIVE}" class="btn btn-sm btn-info btn-block mt-2">Quick View (${targetMarker.live_count} Live)</a>
        </div>`;
    }

    async onViewHistoryButtonClick(id) {

        (this.$refs['dealership-history-modal'] as any).show();

        this.loadingDealershipVehicleHistory = true;

        try {
            this.lastThreeMonthVehicleCountResults = await getVehicleCountForLastThreeMonthsForDealer(id);
        } catch (e) {

        } finally {
            this.loadingDealershipVehicleHistory = false;
        }
    }

    onInfoWindowDealershipLinkClick(uri: string) {
        this.$router.push(this.BuildDealershipLink(uri))
    }

    async onCenterMapButtonClick() {
        const map = await (this.$refs.mapRef as any).$mapPromise;

        map.setZoom(4);
        map.panTo(this.mapCenterLocation);
    }

    get getMarkersFilteredByActiveLegend() {

        return this.markers.filter((marker: Dealership) => {

            if(marker.id === this.currentlySelectedDealerSearchItem) {

                return true

            } else {

                let result = true;

                if(!this.mapDealershipFilters.activeAccident && marker.is_active && marker.has_recent_accidents) {
                    result = false;
                }

                if(!this.mapDealershipFilters.activeNoAccident && marker.is_active && !marker.has_recent_accidents) {
                    result = false;
                }

                if(!this.mapDealershipFilters.inactiveAccident && !marker.is_active && marker.has_recent_accidents) {
                    result = false;
                }

                if(!this.mapDealershipFilters.inactiveNoAccident && !marker.is_active && !marker.has_recent_accidents) {
                    result = false;
                }

                return result;

            }
        });

    }
}
